import React from 'react';
const IconTwitterX = ({ width = 20, height = 20, color = 'currentColor' }) => {
    return (React.createElement("svg", { width: width, height: height, viewBox: "0 0 22 21", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M7 0.58667H0L8.26 11.6007L0.45 20.5867H3.1L9.488 13.2377L15 20.5867H22L13.392 9.10867L20.8 0.58667H18.15L12.164 7.47267L7 0.58667ZM16 18.5867L4 2.58667H6L18 18.5867H16Z", fill: color })));
};
export default IconTwitterX;
